import { render, staticRenderFns } from "./NewPublication.vue?vue&type=template&id=58caf3a8&scoped=true"
import script from "./NewPublication.vue?vue&type=script&lang=js"
export * from "./NewPublication.vue?vue&type=script&lang=js"
import style0 from "./NewPublication.vue?vue&type=style&index=0&id=58caf3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58caf3a8",
  null
  
)

export default component.exports